import api from '.'

type PaddleBillingPaymentMethod = {
  id: string
  customerId: string
  type: 'card' | 'google_pay' | 'apple_pay' | 'paypal'
  card: {
    type: string
    last4: string
    expiryMonth: number
    expiryYear: number
    cardholderName: string
  } | null
  paypal: {
    email: string
    reference: string
  } | null
  origin: 'subscription' | 'saved_during_purchase'
  savedAt: string
  updatedAt: string
}

export const getPaddleBillingCustomerIdInnerRoute = async () => {
  const data = await api.get('/api/paddle-billing/customer-id')
  return data.data as string
}

export const previewChangeOfPaddleBillingSubscriptionPlanInnerRoute = async (priceId: string) => {
  const data = await api.put('/api/paddle-billing/update-subscription-preview', { priceId })
  return data.data
}

export const changePaddleBillingSubscriptionPlanInnerRoute = async (priceId: string) => {
  const data = await api.put('/api/paddle-billing/update-subscription', { priceId })
  return data.data
}

export const cancelPaddleBillingSubscriptionInnerRoute = async () => {
  await api.delete('/api/paddle-billing/cancel-subscription')
}

export const devOnlyDeleteUserSubscriptionInnerRoute = async () => {
  await api.delete('/api/paddle-billing/dev-only-delete-subscription')
}

export const getPaddleBillingPaymentMethodsInnerRoute = async () => {
  const data = await api.get('/api/paddle-billing/payment-methods')
  return data.data as PaddleBillingPaymentMethod[]
}

export const applyCancelSequenceDiscountInnerRoute = async () => {
  const data = await api.post('/api/paddle-billing/apply-cancel-sequence-discount')
  return data.data as { message: string }
}

export const getPaddleBillingPlanConfigs = async (priceIds: string[]) => {
  const data = await api.post('/api/paddle-billing/plan-configs', { priceIds })
  return data.data
}

export const trackPaddleBillingProPlanLimitInnerRoute = async (type: 'limit' | 'request', limitType: string) => {
  const data = await api.post('/api/paddle-billing/track-pro-plan-limit', { type, limitType })
  return data.data
}

export const getPaddleBillingPortalUrlInnerRoute = async () => {
  const data = await api.get('/api/paddle-billing/portal-url')
  return data.data as string
}